import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { ProyectoEditPage } from '@/pages/proyecto-edit';

export const Route = createFileRoute('/_private/proyectos/$id/editar')({
  beforeLoad: () => exigirAcceso('proyectos', 'update'),
  component: ProyectoEditPage,
});
